import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import axios from "axios";
import Graph from "../../../../components/Util/Graph";
import "./PatientDetailPopup.css";
import { tab } from "@testing-library/user-event/dist/tab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNotesMedical } from "@fortawesome/free-solid-svg-icons";
import weightIcon from "../../../../assets/icons/weight.png";
import tempIcon from "../../../../assets/icons/temperature.png";
import bloodpressIcon from "../../../../assets/icons/bloodpressure.png";
import bloodIcon from "../../../../assets/icons/blood.png";
import { getServerBaseUrl } from "../../../../utils/portConfig";

function PatientPopup({ isOpen, onClose, patientDetails }) {
  // 초기 데이터 설정
  const initialPatientDetailData = {
    patientName: patientDetails ? patientDetails.patientName : "",
    patientId: patientDetails ? patientDetails.patientId : "",
    age: patientDetails ? patientDetails.age : "",
  };

  const [patientDetailData, setPatientDetailData] = useState({ ...initialPatientDetailData });
  const [selectedTab, setSelectedTab] = useState("진료기록");
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState([]);
  const [pRecordData, setPrecordData] = useState([]);
  const [groupedRecords, setGroupedRecords] = useState({});

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1`;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (isOpen) {
      setPatientDetailData({
        patientName: patientDetails ? patientDetails.patientName : "",
        patientId: patientDetails ? patientDetails.patientId : "",
        age: patientDetails ? patientDetails.age : "",
      });
    }
  }, [isOpen, patientDetails]);

  useEffect(() => {
    if (patientDetails) {
      getDetailPatientData();
      getPatientChartData();
    }
  }, [patientDetails]);

  // VITAL 그래프용 데이터 조회
  const getPatientChartData = async () => {
    try {
      const response = await axios.get(`${API_SERVER_URL}/checklist/getPHRData/${patientDetails.patientId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        setChartData((prevChartData) => ({
          ...prevChartData,
          ...response.data,
        }));
      }
    } catch (error) {
      console.error("서버 오류: getPHRData error:", error);
    }
  };

  // 환자 진료기록 - 상세 조회
  const getDetailPatientData = async () => {
    try {
      const response = await axios.get(`${API_SERVER_URL}/record/${patientDetails.patientId}/record`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const recordList = response.data.flatMap((item) => {
          const records = [];
          const commonRecordObj = {
            date: item.regDate.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3"),
          };
          if (item.sangList.length !== 0) {
            item.sangList.forEach((sang) => {
              const recordObj = {
                ...commonRecordObj,
                category: "증상",
                name: sang.codeName,
              };
              if (item.preList.length !== 0) {
                item.preList.forEach((pre) => {
                  if (sang.regDate === pre.regDate) {
                    recordObj.prescription = pre.codeName;
                  }
                });
              }
              records.push(recordObj);
            });
          }

          if (item.patientTestList.length !== 0) {
            item.patientTestList.forEach((test, index) => {
              const recordObj = {
                ...commonRecordObj,
                category: "검사",
                name: test.testName,
              };
              if (test.testDetail.length !== 0) {
                test.testDetail.forEach((td, tIndex) => {
                  const detailRecordObj = {
                    ...recordObj,
                    status: td.testResult,
                    description: td.testName,
                  };
                  records.push(detailRecordObj);
                });
              } else {
                // testDetail이 비어있을 때의 처리
                records.push(recordObj);
              }
            });
          }
          if (item.noticeList.length !== 0) {
            item.noticeList.forEach((note) => {
              const recordObj = {
                ...commonRecordObj,
                doctorNote: note.comments,
              };
              records.push(recordObj);
            });
          }
          return records;
        });
        setPrecordData(recordList);
        setLoading(false);
      }
    } catch (error) {
      console.error("서버 오류: getPatientRecordData error:", error);
    }
  };

  useEffect(() => {
    if (!loading) {
      const grouped = pRecordData.reduce((acc, record) => {
        acc[record.date] = acc[record.date] ? [...acc[record.date], record] : [record];
        return acc;
      }, {});
      setGroupedRecords(grouped);
    }
  }, [loading, pRecordData, setGroupedRecords]);

  // 탭을 클릭했을 때 호출되는 함수
  const handleTabClick = (tabName) => {
    setSelectedTab(tabName);
  };

  const tabAreaStyle = {
    backgroundColor: selectedTab === "진료기록" ? "white" : "white",
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="User Popup"
      style={{
        overlay: {
          backgroundColor: "rgdba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "1px solid #ccc",
          background: "white",
          borderRadius: "4px",
          width: "430px",
          height: "655px",
        },
      }}
    >
      <div className="patient-detail-container">
        <div className="patient-detail-header">
          <h2>
            {patientDetailData.patientName}({patientDetailData.age}세)
          </h2>
        </div>
        <div className="patient-detail-body">
          <div className="patient-tab-area" style={tabAreaStyle}>
            <div className={`p-tab ${selectedTab === "진료기록" ? "selected-tab" : ""}`} onClick={() => handleTabClick("진료기록")}>
              진료기록
            </div>
            <div className={`p-tab ${selectedTab === "VITAL" ? "selected-tab" : ""}`} onClick={() => handleTabClick("VITAL")}>
              VITAL
            </div>
          </div>
          <div className="patient-tab-body-area">
            {selectedTab === "진료기록" && (
              <div className="patient-record-container">
                {Object.keys(groupedRecords).map((date, index) => (
                  <div key={`${index}-prg`} className="patient-records-group">
                    <div className="patient-records-header">{date}</div>
                    <div className="patient-record-card">
                      {groupedRecords[date].map(
                        (record, index) =>
                          record.category !== undefined && (
                            <React.Fragment key={`${record.date}-${index}`}>
                              <div className="patient-record-info">
                                <div className="patient-record-info-sub">
                                  <div className={`record-category category-${record.category}`}>{record.category}</div>
                                  <div className="patient-record-info-sub-title">
                                    <div className="patient-record-name">{record.name}</div>
                                    <div className="patient-record-description">{record.description}</div>
                                  </div>
                                  {record.category === "검사" && <div className={`${record.status === "A" ? "abnormal" : "record-status"}`}>{`${record.status}` === "N" ? "정상" : "비정상"}</div>}
                                </div>
                              </div>
                              {record.category === "증상" && (
                                <div className="patient-record-info">
                                  <div className="record-category category-처방">처방</div>
                                  <div className="patient-record-name">{record.prescription}</div>
                                </div>
                              )}
                            </React.Fragment>
                          )
                      )}
                      <div className="patient-record-card-dorctorNote">
                        {groupedRecords[date] && groupedRecords[date].some((doc) => doc.doctorNote) && (
                          <div className="patient-doctorNote-header">
                            <FontAwesomeIcon icon={faNotesMedical} /> <label>의사소견</label>
                          </div>
                        )}
                        {groupedRecords[date].map(
                          (doc, dIndex) => doc.doctorNote && <div key={dIndex} className="patient-record-doctor-note" dangerouslySetInnerHTML={{ __html: `${doc.doctorNote}` }}></div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {selectedTab === "VITAL" && (
              <div className="patient-record-container">
                {chartData && (
                  <div>
                    <div className="graph-card">
                      <div className="graph-card-title">
                        <div className="weight-icon">
                          <img src={weightIcon} />
                        </div>
                        <div className="graph-title">BMI</div>
                      </div>
                      <Graph
                        data={chartData.bmi}
                        category={chartData.categories}
                        tooltipFormatter={(value) => `BMI ${value}`}
                        redLines={[
                          { value: 18.5, color: "red" },
                          { value: 23, color: "red" },
                        ]}
                      />
                    </div>
                    <div className="graph-card">
                      <div className="graph-card-title">
                        <div className="weight-icon">
                          <img src={tempIcon} />
                        </div>
                        <div className="graph-title">체온</div>
                      </div>
                      <Graph
                        data={chartData.temperatureList}
                        category={chartData.categories}
                        tooltipFormatter={(value) => `${value} °C`}
                        redLines={[
                          { value: 36, color: "red" },
                          { value: 37.5, color: "red" },
                        ]}
                      />
                    </div>
                    <div className="graph-card">
                      <div className="graph-card-title">
                        <div className="weight-icon">
                          <img src={bloodpressIcon} />
                        </div>
                        <div className="graph-title">혈압</div>
                      </div>
                      <Graph
                        data={[chartData.minBloodPressureList, chartData.maxBloodPressureList]}
                        category={chartData.categories}
                        tooltipFormatter={(value) => `${value} mmHg`}
                        lineColors={["#FF5733", "#33FF57"]}
                        redLines={[
                          { value: 70, color: "red" },
                          { value: 140, color: "red" },
                        ]}
                      />
                    </div>
                    <div className="graph-card">
                      <div className="graph-card-title">
                        <div className="weight-icon">
                          <img src={bloodIcon} />
                        </div>
                        <div className="graph-title">혈당</div>
                      </div>
                      <Graph
                        data={chartData.bloodGlucoseList}
                        category={chartData.categories}
                        tooltipFormatter={(value) => `${value} mg/dL`}
                        redLines={[
                          { value: 70, color: "red" },
                          { value: 99, color: "red" },
                        ]}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="patient-detail-footer">
          <button className="dashboard-content-button popup-button" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </Modal>
  );
}
export default PatientPopup;
